import Browser from '@mindful-web/marko-web/browser';
import Shared from '@ascend-media/package-global-monorail/browser';

Shared(Browser);

export default Browser;
